import { type TCfContext } from '../../types/cfContextTypes'

let context: TCfContext | undefined

export const seedCfContext = (seeded?: TCfContext | null) => {
    context = seeded ?? undefined
}

export const readCachedCfContext = (): TCfContext | undefined => context
